import { CommonEnums } from '../../common.enums';
import { JsonC_Inst } from './jsonc_inst';
import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Conn_Db_Obj_LnksUtil } from 'src/app/shared/utils/conn_db_obj_lnks.util';
import { DxFlow_Obj_PropertiesUtil } from 'src/app/shared/utils/dxflow_obj_properties.util';
import { Obj_Db_PropertyUtil } from 'src/app/shared/utils/obj_db_property.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';

export class JsonC {
    jsonC_Inst: JsonC_Inst;
    conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>;
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: string;
    column_Properties: Array<Obj_Db_Property>;
    jsonC_Properties: Array<Obj_Db_Property>;
    target_Properties: Array<Obj_Db_Property>;
    file_Properties: Array<Obj_Db_Property>;
    sel_File_PropertyType_Cd: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.jsonC_Inst = new JsonC_Inst();
        this.conn_Db_Obj_Lnks = new Array<Conn_Db_Obj_Lnk>();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
        this.change_Ind =  CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.STRING_EMPTY;
        this.column_Properties = new Array<Obj_Db_Property>();
        this.jsonC_Properties = new Array<Obj_Db_Property>();
        this.target_Properties = new Array<Obj_Db_Property>();
        this.file_Properties = new Array<Obj_Db_Property>();
    }

    static parse(jsoncTmp: JsonC): JsonC {
        let jsonc: JsonC = new JsonC();
        jsonc.copyFrom(jsoncTmp);
        return jsonc;
    }

    copy(): JsonC {
        let jsoncTmp: JsonC = new JsonC();

        jsoncTmp.jsonC_Inst = this.jsonC_Inst.copy();
        jsoncTmp.conn_Db_Obj_Lnks = Conn_Db_Obj_LnksUtil.getInstance().copy(this.conn_Db_Obj_Lnks);
        jsoncTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
        jsoncTmp.change_Ind = this.change_Ind;
        jsoncTmp.error_Cd = this.error_Cd;
        jsoncTmp.error_Msg = this.error_Msg;
        jsoncTmp.ref_Id = this.ref_Id;
        jsoncTmp.ref_Cd = this.ref_Cd;
        jsoncTmp.fldr_Id = this.fldr_Id;
        jsoncTmp.column_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.column_Properties);
        jsoncTmp.jsonC_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.jsonC_Properties);
        jsoncTmp.target_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.target_Properties);
        jsoncTmp.file_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.file_Properties);
        return jsoncTmp;
    }

    copyFrom(jsoncTmp: JsonC): void {
        this.jsonC_Inst.copyFrom(jsoncTmp.jsonC_Inst);
        Conn_Db_Obj_LnksUtil.getInstance().copyFrom(this.conn_Db_Obj_Lnks, jsoncTmp.conn_Db_Obj_Lnks);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, jsoncTmp.dxFlow_Obj_Properties);
        this.change_Ind = jsoncTmp.change_Ind;
        this.error_Cd = jsoncTmp.error_Cd;
        this.error_Msg = jsoncTmp.error_Msg;
        this.ref_Id = jsoncTmp.ref_Id;
        this.ref_Cd= jsoncTmp.ref_Cd;
        this.fldr_Id = jsoncTmp.fldr_Id;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.column_Properties, jsoncTmp.column_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.jsonC_Properties, jsoncTmp.jsonC_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.target_Properties, jsoncTmp.target_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.file_Properties, jsoncTmp.file_Properties);

    }

    compare(jsoncTmp: JsonC): string {
        let diffString = '';
        diffString = (this.jsonC_Inst).compare(jsoncTmp.jsonC_Inst);
        if (diffString != '') return diffString;

        diffString = Conn_Db_Obj_LnksUtil.getInstance().compare(this.conn_Db_Obj_Lnks, jsoncTmp.conn_Db_Obj_Lnks);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.jsonC_Properties, jsoncTmp.jsonC_Properties);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.column_Properties, jsoncTmp.column_Properties);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.target_Properties, jsoncTmp.target_Properties);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.file_Properties, jsoncTmp.file_Properties);
        if (diffString != '') return diffString;

        return diffString;
    }

    toString(): string {
        return "JsonC [jsonc_Inst=" + this.jsonC_Inst +
            ", conn_Db_Obj_Lnks=" + Conn_Db_Obj_LnksUtil.getInstance().toString(this.conn_Db_Obj_Lnks) +
            ", dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties) +
            ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Id=" + this.ref_Id +
            ", ref_Cd=" + this.ref_Cd +
            ", fldr_Id=" + this.fldr_Id +
            ", column_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.column_Properties) +
            ", jsonC_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.jsonC_Properties) +
            ", target_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.target_Properties) +
            ", file_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.file_Properties) + "]"
    }
}